import { computed } from 'mobx';

import { POLICY_APPLICATIONS, EVENT_POLICY_METRICS } from '@kentik/ui-shared/alerting/constants';
import { EVENT_TYPE_OPTIONS } from 'app/forms/config/kevent/constants';

import { isSyslogEventPolicy, isSnmpTrapEventPolicy } from 'app/stores/alerting/policyUtils';
import { TARGET_TYPES } from 'app/forms/config/unified/constants';
import FlowPolicyModel from '../FlowPolicyModel';

class EventPolicyModel extends FlowPolicyModel {
  constructor(attributes = {}, options = {}) {
    super({ ...attributes, application: POLICY_APPLICATIONS.KEVENT }, { deserialize: true, ...options });
  }

  get urlRoot() {
    return '/api/ui/alerting/policies/kevent';
  }

  @computed
  get isSyslogEventPolicy() {
    return isSyslogEventPolicy(this.dimensions);
  }

  @computed
  get isSnmpTrapEventPolicy() {
    return isSnmpTrapEventPolicy(this.dimensions);
  }

  get metrics() {
    if (this.isSyslogEventPolicy) {
      return [EVENT_POLICY_METRICS.SYSLOG];
    }

    if (this.isSnmpTrapEventPolicy) {
      return [EVENT_POLICY_METRICS.SNMP_TRAP];
    }

    return this.get('metrics');
  }

  // TODO: we do, but we shouldn't change this in FlowPolicyModel during serialization
  get userId() {
    return this.get('userID');
  }

  get targetType() {
    return TARGET_TYPES.EVENT;
  }

  get filters() {
    return this.get('filters') || {};
  }

  clonePolicy(overrides = {}) {
    const { id, name, thresholds = [], activationSettings = {}, rule, ...clonedPolicyAttrs } = this.get();
    const clonedPolicy = new this.constructor(clonedPolicyAttrs, { deserialize: false });

    delete activationSettings.ruleId;

    clonedPolicy.set({
      name: `${name} (Clone)`,
      thresholds: thresholds.map(({ thresholdID, policyID, ...threshold }) => threshold),
      activationSettings,
      minTrafficValue: 0,
      ...overrides
    });

    return clonedPolicy;
  }

  getPolicyFormValues = () => {
    // Query to policy
    if (this.get('explorerPolicy')) {
      const { filters = {}, dimensions, eventType } = this.get('explorerPolicy', {});
      const eventTypeLabel = EVENT_TYPE_OPTIONS.find(({ value }) => eventType === value)?.label;

      this.set('name', `${eventTypeLabel} Alert Policy`);
      const explorerFormData = this.get();
      explorerFormData.uiProperties = { eventType, targetType: this.targetType }; // TODO: do we need this?
      explorerFormData.dimensions = dimensions;
      explorerFormData.filters = { ...explorerFormData.filters, ...filters };
      return explorerFormData;
    }

    // Editing or cloning policy
    if (!this.isNew || this?.name?.endsWith('(Clone)')) {
      return this.get();
    }

    // Brand new policy
    return this.deserialize({ application: POLICY_APPLICATIONS.KEVENT });
  };
}

export default EventPolicyModel;
